import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { Logo } from "../Logo";
import { useLang } from "../../i18n";
import { CONTACT } from "../../data/content";

export const Footer = () => {
  const { ui, L, lang } = useLang();
  const slogan =
    lang === "ro"
      ? "Energie, Automatizare și Siguranță pentru Viitor."
      : "Energy, Automation and Safety for the Future.";

  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-ink">
      <div className="pointer-events-none absolute -top-40 left-1/2 h-80 w-[120%] -translate-x-1/2 rounded-[100%] bg-brand-deep/20 blur-3xl" />
      <div className="container-pdr relative py-20">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <Logo />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/55">
              {lang === "ro"
                ? "Proiectăm și implementăm instalații electrice, soluții smart home și automatizări profesionale pentru locuințe, spații comerciale și industrie."
                : "We design and implement electrical systems, smart home solutions and professional automation for homes, commercial spaces and industry."}
            </p>
            <p className="mt-5 font-mono text-xs uppercase tracking-widest text-white/40" data-testid="footer-company">
              VOLT PDR SRL · CUI RO49673891
            </p>
          </div>

          <div>
            <h4 className="mono-label mb-5">{ui.nav.contact}</h4>
            <ul className="space-y-3 text-sm text-white/65">
              <li className="flex items-center gap-3"><Phone className="h-4 w-4 text-brand" /><a href={`tel:${CONTACT.phoneHref}`} className="hover:text-white">{CONTACT.phone}</a></li>
              <li className="flex items-center gap-3"><Mail className="h-4 w-4 text-brand" /><a href={`mailto:${CONTACT.email}`} className="hover:text-white">{CONTACT.email}</a></li>
              <li className="flex items-start gap-3"><MapPin className="mt-0.5 h-4 w-4 text-brand" /><span>{L(CONTACT.address)}</span></li>
            </ul>
          </div>

          <div>
            <h4 className="mono-label mb-5">Nav</h4>
            <ul className="space-y-3 text-sm">
              {[
                { to: "/", label: ui.nav.home },
                { to: "/portofoliu", label: ui.nav.portfolio },
                { to: "/despre", label: ui.nav.about },
                { to: "/contact", label: ui.nav.contact },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="group inline-flex items-center gap-1 text-white/65 transition-colors hover:text-white">
                    {l.label}
                    <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-all group-hover:translate-x-0.5 group-hover:opacity-100" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 border-t border-white/10 pt-8">
          <p className="font-display text-2xl font-bold text-gradient-glow md:text-4xl">
            VOLTPDR — {slogan}
          </p>

          {/* ANPC badges */}
          <div className="mt-8 flex flex-wrap items-center gap-3" data-testid="anpc-badges">
            <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="nofollow noreferrer" aria-label="ANPC SAL" data-testid="anpc-sal">
              <img src="https://kitamaru.ro/images/anpc/anpc-sal.webp" alt="Soluționarea Alternativă a Litigiilor" className="h-auto w-[220px] rounded-md" loading="lazy" />
            </a>
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="nofollow noreferrer" aria-label="ANPC SOL" data-testid="anpc-sol">
              <img src="https://kitamaru.ro/images/anpc/anpc-sol.webp" alt="Soluționarea Online a Litigiilor" className="h-auto w-[220px] rounded-md" loading="lazy" />
            </a>
          </div>

          <div className="mt-8 flex flex-col gap-4 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
            <p className="font-mono text-xs text-white/40">
              © {new Date().getFullYear()} VOLT PDR SRL · CUI RO49673891 · voltpdr.ro
            </p>
            <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
              <Link to="/termeni" data-testid="footer-terms-link" className="text-white/55 transition-colors hover:text-white">
                {lang === "ro" ? "Termeni și condiții" : "Terms & Conditions"}
              </Link>
              <Link to="/cookies" data-testid="footer-cookies-link" className="text-white/55 transition-colors hover:text-white">
                {lang === "ro" ? "Politica de Cookies" : "Cookie Policy"}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
